import * as React from "react";
import ReactPlayer from 'react-player'

import { Text, TranslationsProvider } from '@eo-locale/react';
import '@blueprintjs/core/lib/css/blueprint.css';
import { Intent, Classes } from "@blueprintjs/core";
import { Button, Card, Elevation, Overlay,H4 } from "@blueprintjs/core";
import{HomeProps} from './Home.tsx'
import CardEditor from "./CardEditor.tsx";
//import { Example } from '@blueprintjs/docs-theme';
//import { DialogExample } from './components/dialogExample';

import PanelNom from './PanelNom.tsx';
import PanelEmail from './PanelEmail.tsx';
import PanelPassword from './PanelPassword.tsx';
import PanelOnePassword from './PanelOnePassword.tsx';
import MyToaster from './components/MyToaster.tsx';
import { type, userInfo } from "os";

import {Toaster, Position} from "@blueprintjs/core";
const toaster=Toaster.create({
  className: "my-toaster",
  position: Position.TOP_RIGHT
});

// Create the XHR object.
/*function createCORSRequest(method, url) {
  var xhr = new XMLHttpRequest();
  if ("withCredentials" in xhr) {
    // XHR for Chrome/Firefox/Opera/Safari.
    xhr.withCredentials = true;
    xhr.open(method, url, true);
   // xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencode');
    xhr.setRequestHeader('Access-Control-Expose-Headers','*, Authorization');
    xhr.setRequestHeader('Access-Control-Allow-Headers','*');
    xhr.setRequestHeader('Access-Control-Allow-Origin','*')
  }
  return xhr;
}*/



// Make the actual CORS request.
/*function makeCorsRequest(url) {
  // This is a sample server that supports CORS.
 // var url = 'http://html5rocks-cors.s3-website-us-east-1.amazonaws.com/index.html';

  var xhr = createCORSRequest('HEAD', url);
  if (!xhr) {
   // alert('CORS not supported');
    return;
  }

  // Response handlers.
  xhr.onload = function() {
    //var text = xhr.responseText;
    console.log(xhr.getAllResponseHeaders());
   // console.log('Response from CORS request to ' + url + ': ' + text);
  };

  xhr.onerror = function(e) {
    console.log(xhr.getAllResponseHeaders());
    console.log('Woops, there was an error making the request.'+e);
  };

  xhr.send();
}*/

export default class CardDocumentWeb extends React.Component  <HomeProps> {
  state = {
    name: '',
    force_height:'240px',
    force_height2:'0px',
    force_width:'360px',
    parent_height:480,
    isOpenEdit:false,
    isOpenDelete:false,
    title_document_creation:'',
    description_document_creation:'',
    objectif_document_creation:'',
    typeflex:'initial',
    status_published:"eye-off",
    youtube_frame:'',
    showcontenu:'block',
    url_video:'',
    elargir:'arrow-right',
    url_video2:'',
    crossdomain:false,
  }  
  conteneurRef=null;
  conteneurRef_iframe=null;
  constructor(props) {
        super(props);
        if(this.props.handleEdition!=undefined)this.props.handleEdition.bind(this);
        this.conteneurRef = React.createRef()
        this.conteneurRef_iframe = React.createRef()
       // this.handleChange = this.handleChange.bind(this);
      }
  componentDidMount () { 
  // console.log("componentDidMount dans CardDocument")
  //  console.log(this.props);
  var that=this;
   this.setState({title_document_creation:this.props.title_document});
   this.setState({description_document_creation:this.props.description});
   this.setState({objectif_document_creation:this.props.objectif})
   this.setState({youtube_frame:this.props.youtube_frame});
   this.setState({url_video:this.props.url_video});
   this.setState({url_video2:this.props.url_video});
    if(this.props.type_audio =='true') {
        this.setState({force_height:'80px'}); 
        //this.setState({force_width:'30px'});
    }//else this.setState({force_height:'480'});
    if(this.props.type_audio =='true') this.setState({parent_height:280})
    else this.setState({parent_height:480})
    if(this.props.type_audio =='true') this.setState({typeflex:'100%'})
    else this.setState({typeflex:'initial'})
    

    
  /*  if(this.props.config =='true') {
      this.setState({force_width:'480px'});
    }*/
  }
 
  componentDidUpdate(prevProps, prevState) {
    
   /* if(prevProps.title_document!=this.state.title_document_creation) this.setState({title_document_creation:prevProps.title_document});
    if(prevProps.description!=this.state.description_document_creation) this.setState({description_document_creation:prevProps.description});
    if(prevProps.objectif!=this.state.objectif_document_creation) this.setState({objectif_document_creation:prevProps.objectif});*/
    if(prevProps.youtube_frame!=this.state.youtube_frame) this.setState({youtube_frame:prevProps.youtube_frame});
    if(prevProps.youtube_frame=='true') 
    {
      if(prevProps.url_video!=this.state.url_video) this.setState({url_video:prevProps.url_video});
    }
    else{
      if(prevProps.url_video!=this.state.url_video2) this.setState({url_video2:prevProps.url_video});
    }
    if(this.props.type_audio !='true')
    {
      if(this.conteneurRef.clientWidth!=undefined) 
      {
        
        var icross=false;
        if (this.conteneurRef_iframe!=null)
        {
                 // this.setState({crossdomain:false});
                 var st=this.conteneurRef_iframe.children[0].contentDocument;
                 console.log(this.conteneurRef_iframe);
                 if(st!=null){
                  console.log(this.conteneurRef_iframe.children[0].contentDocument.body.innerHTML);
                  icross=true;
                 }
                 else icross=false;
                 //if(item_iframe.contentDocument!=undefined)   console.log(item_iframe.contentWindow);
            
        }
        else
        {
         // this.setState({crossdomain:true});
          //this.setState({force_height2:'0px'});
        }
       /* if(this.conteneurRef.clientWidth>0) {
          var larg=this.conteneurRef.clientWidth;
          larg=larg/1.33;
          larg=parseInt(larg);
          if(this.state.force_height != larg)
          {
            this.setState({force_height:larg});
            larg=larg*2;
            if(!icross)larg=0;
            this.setState({force_height2:larg});
          }
        }*/
        console.log(this.conteneurRef.clientWidth);
      }
    }
    //console.log(this.state.youtube_frame);
    ////<div dangerouslySetInnerHTML={{ __html: "<iframe style='height:280px;' src='"+url_video+"' />"}} />
  }
  
  handle_published=()=>
  {
    console.log("handle_published");
    if(this.state.status_published=='eye-off'){
      this.setState({status_published:'eye-open'});
      toaster.show( {icon:'eye-open', intent:Intent.SUCCESS,timeout:2000,message:"Le document est disponible en ligne"});
    }else{
      this.setState({status_published:'eye-off'});
      toaster.show( {icon:'eye-off', intent:Intent.DANGER,timeout:2000,message:"Le document n'est plus disponible en ligne"});
    }
  }
  handletaille=()=>{
    this.setState({force_width:"100%"});
    this.setState({showcontenu:"block"});
    this.setState({elargir:"arrow-left"});
  }
   render() {
    
    const {type_audio,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handleSelectionGetLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;
    
   
    

    return(
     <div style={{display:isnotdocument,width:this.state.force_width,minWidth: 360,margin:4,flex:this.state.typeflex,zIndex:1}}>
     
     
     <Card style={{width:this.state.force_width,margin:4,objectFit:'contain'}} interactive={true} elevation={Elevation.TWO}>
     <div style={{textAlign: 'right'}}>
       <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"80px"});this.setState({showcontenu:"none"});this.setState({typeflex:'initial'})}} className={Classes.OUTLINED } icon="minimize" title="Réduire" />
       <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"480px"});this.setState({showcontenu:"block"});if(this.props.type_audio =='true') this.setState({typeflex:'100%'});if(this.props.type_audio =='true') this.setState({parent_height:280})}} className={Classes.OUTLINED } icon="maximize" title="Augmenter" />
       <Button onClick={(ev)=>{
          ev.preventDefault();
          if(this.state.elargir=='arrow-right')
          {
            this.setState({force_width:"100%"});
            this.setState({showcontenu:"block"});
            this.setState({elargir:"arrow-left"});
          }
          else
          {
            this.setState({force_width:"360px"});
            this.setState({elargir:"arrow-right"});
          }
        }}
              
        className={Classes.OUTLINED } icon={this.state.elargir} title="Elargir" />
     </div>
     {this.props.toolbar!='true'?<CardEditor _onUploadtext={this.props._onUploadtext} fromChildren={this.props.fromChildren} matiere_id={this.props.matiere_id} handletaille={this.handletaille} userid={this.props.userid} recordingsbydate={this.props.recordingsbydate} id_document={this.props.id_document} title_document={title_document}/>:null}
     <h3><a href="">{title_document}</a></h3>
     <p><b>{description}</b></p>
     <p>{objectif}</p>
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:true});}} className={Classes.OUTLINED +" "+ Classes.LARGE} icon="edit" title="Editer" />:<div></div>}
     {this.props.toolbar=='true'?<Button onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:true});}} className={Classes.OUTLINED+" "+ Classes.INTENT_DANGER +" " + Classes.LARGE} icon="trash" title="Effacer" />:<div></div>}
     {this.props.toolbar=='true'?<Button className={Classes.OUTLINED+" "+ Classes.LARGE +" "+ Classes.INTENT_WARNING} icon={this.state.status_published} title="Cours en ligne" onClick={(ev)=>{ev.preventDefault();this.handle_published();}}/>:<div></div>}
     <Overlay isOpen={this.state.isOpenDelete} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Effacer le document {this.props.title_document}</H4>
                       
                        <p style={{marginTop:20}}>
                           Etes-vous sûr de vouloir effacer le document {this.props.title_document} ?
                        </p>
                                              
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isOpenDelete:false});
                              
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              var that=this;
                              xhr.open('GET','/api/public/deldocument?id_document='+this.props.id_document)
                              this.setState({file:''})
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send();

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          console.log(xhr.responseText);
                                          //that.props.onchildrenevent();
                                          that.props.LoadDataDocumentsDirect(-1)
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
     </Overlay>
     <div ref={(ref) => this.conteneurRef = ref} style={{display:this.state.showcontenu}}>
     <Button style={{marginLeft:10}} onClick={(ev)=>{ev.preventDefault();if(this.state.force_height2=='0px')this.setState({force_height2:'800px'}); else this.setState({force_height2:'0px'})}}>{this.state.force_height2 != '0px' ? 'Réduire' : 'Agrandir'}</Button> 
     <div style={{padding:5,margin:"5px"}}><a href={this.state.url_video} target="_blank"><b>Visiter le site</b></a></div>
     <div style={{height:this.state.force_height2}} ref={(ref) => this.conteneurRef_iframe = ref} dangerouslySetInnerHTML={{ __html: "<iframe  id='id_frame' style='height:100%;width:100%;border:0' src='"+this.state.url_video+"' />"}}/>
     </div>
     </Card>
     <Overlay isOpen={this.state.isOpenEdit} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
      
      <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
      
        <H4>Edition d'un document</H4>
        <div style={{marginTop:5}}><span>Titre</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:ev.target.value,description:this.state.description_document_creation,objectif:this.state.objectif_document_creation});this.setState({title_document_creation:ev.target.value})}} value={this.state.title_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir le titre de votre document"/></div>
        <div style={{marginTop:5}}><span>Description</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:ev.target.value,objectif:this.state.objectif_document_creation});this.setState({description_document_creation:ev.target.value})}} value={this.state.description_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir une description votre document"/></div>
        <div style={{marginTop:5}}><span>Objectif</span><input onChange={(ev)=>{this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:this.state.description_document_creation,objectif:ev.target.value});this.setState({objectif_document_creation:ev.target.value})}} value={this.state.objectif_document_creation} style={{padding:4,width:'100%'}} type="text" placeholder="Saisir un objectif ou une consigne"/></div>
        <div style={{marginTop:10}}>
          <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenEdit:false});}}>Annuler</Button>
          <Button style={{marginLeft:5}} intent={Intent.SUCCESS} onClick={(ev)=>{ev.preventDefault();this.props.handleEdition({id:this.props.id,title:this.state.title_document_creation,description:this.state.description_document_creation,objectif:this.state.objectif_document_creation,update:true});this.setState({isOpenEdit:false});}}>Valider la modification</Button>
        </div>
      </div>
      </Overlay>
     
     
     </div>);
}
}
